import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const List = React.forwardRef(function List({ className, ...rest }, ref) {
  return <li className={cx('dnd-list__item', className)} {...rest} ref={ref} />;
});

List.propTypes = {
  className: PropTypes.string,
};

export default List;
